import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { presetRange } from "../domain/funnel/period";
import { useStageColor } from "../deals/useDealStages";
import { useStageLabel } from "../deals/useStageLabel";
import { FunnelChart } from "../reports/common/FunnelChart";
import { dealBars } from "../reports/funnel/funnelView";
import { useReportsClient } from "../reports/ReportsClientContext";
import { useReport } from "../reports/useReport";

/** This month's deal funnel (cohort) with a link to the full report. */
export const FunnelMini = ({ now }: { now: Date }) => {
  const translate = useTranslate();
  const client = useReportsClient();
  const stageLabel = useStageLabel();
  const stageColor = useStageColor();
  const { from, to } = presetRange("this_month", now);
  const q = useReport(["funnel", from, to, { mode: "cohort" }], () =>
    client.funnel(from, to, { mode: "cohort" }),
  );
  const hasDeals = (q.data?.deals ?? []).some((r) => r.reached > 0);
  return (
    <section className="rounded-xl border bg-card p-4">
      {q.data && hasDeals ? (
        <FunnelChart
          title={translate("gavion.dashboard.funnel_title")}
          bars={dealBars(q.data, null, "cohort", stageLabel, stageColor)}
        />
      ) : (
        <>
          <h2 className="mb-2 text-lg font-bold">
            {translate("gavion.dashboard.funnel_title")}
          </h2>
          <p className="text-sm text-muted-foreground">
            {translate("gavion.dashboard.funnel_empty")}
          </p>
        </>
      )}
      <Link
        to="/rapports/entonnoir"
        className="mt-3 inline-block text-sm font-medium text-accent-foreground hover:underline"
      >
        {translate("gavion.dashboard.funnel_link")}
      </Link>
    </section>
  );
};
